import React from "react";
import { configurationStatusPillClass, formatConfigurationStatusLabel } from "../../../web-app";

interface StatusPillProps {
  status: string;
}

const StatusPill = ({ status }: StatusPillProps) => (
  <span className={configurationStatusPillClass(status)}>
    {formatConfigurationStatusLabel(status)}
  </span>
);

export default StatusPill;
